<template>
  <div class="compute">

    <form action="index.php?id=###ID###" method="post">
      <fieldset class="delivery payone">
        <div id="error"></div>
        <h1 class="mb-3">ZAHLUNG</h1>

        <input type="hidden" name="pseudocardpan" id="pseudocardpan">
        <input type="hidden" name="truncatedcardpan" id="truncatedcardpan">
        <input type="hidden" name="cardtypeResponse" id="cardtypeResponse">
        <input type="hidden" name="cardexpiredateResponse" id="cardexpiredateResponse">

        <form action="" class="form">
          <div class="fields">
            <label for="cardholder">Cardholder:</label>
            <input type="text" id="cardholder" placeholder="Cardholder" name="cardholder" value="">

            <label for="cardpanInput">Number:</label>
            <input type="number" id="cardpan" placeholder="Number" name="number" required>

            <label for="expireInput">Expiredate:</label>
            <input type="date" id="expireInput" placeholder="DD/mm/yyyy" name="expiredate" required>

            <label for="cvcInput">CVC:</label>
            <input type="number" id="cardcvc2" placeholder="cvc " name="cvc" required>
            <button type="submit" id="submit" class="button">Submit</button>
          </div>
        </form>
      </fieldset>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Payone',
  data: function () {
    return {
      computes: [],
      flavors: []
    }
  },
  mounted () {
    let payoneScript = document.createElement('script')
    payoneScript.setAttribute('src', 'https://secure.pay1.de/client-api/js/v1/payone_hosted_min.js')
    document.head.appendChild(payoneScript)
    // eslint-disable-next-line one-var
    var request, supportedCardtypes = ['V', 'M', 'D', 'O'], config = {
      fields: {
        cardpan: {
          selector: 'cardpan',
          style: 'height:26px;font-family: tahoma;font-size:11px;width:206px;',
          type: 'input'
        },
        cardcvc2: {
          selector: 'cardcvc2',
          type: 'password', // Could be "text" as well.
          style: 'height:26px;font-family: tahoma;font-size:11px;width:50px;',
          size: '4',
          maxlength: '4',
          length: { 'V': 3, 'M': 3 } // enforce 3 digit CVC für VISA and Mastercard
        },
        cardexpiremonth: {
          selector: 'cardexpiremonth',
          type: 'text', // select (default), text, tel
          size: '2',
          maxlength: '2',
          iframe: {
            width: '34px'
          },
          style: 'height:26px;font-family: tahoma;font-size:11px;width:34px;'
        },
        cardexpireyear: {
          selector: 'cardexpireyear',
          type: 'text', // select (default), text, tel
          iframe: {
            width: '70px'
          },
          style: 'height:26px;font-family: tahoma;font-size:11px;width:50px;'
        }
      },
      defaultStyle: {
        input: 'font-size: 1em; border: 1px solid #000; width: 175px;',
        select: 'font-size: 1em; border: 1px solid #000;',
        iframe: {
          height: '22px',
          width: '180px'
        }
      },
      autoCardtypeDetection: {
        supportedCardtypes: supportedCardtypes,
        callback: function (detectedCardtype) {

        }
        // deactivate: true // To turn off automatic card type detection.
      },
      // eslint-disable-next-line no-undef
      language: Payone.ClientApi.Language.de, //, // Language to display error-messages (default:Payone.ClientApi.Language.en)
      error: 'error' // area to display error-messages (optional)
    }
    request = {
      'request': 'creditcardcheck', 'responsetype': 'JSON', 'mode': 'test', 'mid': '37415', 'aid': '37935', 'portalid': '2026897', 'encoding': 'UTF-8', 'storecarddata': 'yes', 'hash': '###secureHash###'// see Chapter 3.1.5.3
    }
    // eslint-disable-next-line no-undef
    var iframes = new Payone.ClientApi.HostedIFrames(config, request)
    // Function called by submitting PAY-button
    function pay () {
      if (iframes.isComplete()) {
        // Perform "CreditCardCheck" to create and get a PseudoCardPan; then call your function
        // eslint-disable-next-line no-unused-expressions
        'payCallback'
        iframes.creditCardCheck('payCallback')
      } else {
        alert('Not complete. Nothing done.')
      }
    }
    document.getElementById('submit').onclick = function () {
      pay()
    }

    // eslint-disable-next-line no-unused-vars
    function payCallback (response) {
      console.log(response)
      if (response.status === 'VALID') {
        document.getElementById('pseudocardpan').value = response.pseudocardpan
        document.getElementById('truncatedcardpan').value = response.truncatedcardpan
        document.getElementById('cardtypeResponse').value = response.cardtype
        document.getElementById('cardexpiredateResponse').value = response.cardexpiredate
      }
    }
  }
}

</script>
<style>
  .main-content .payone h1 {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Payone.vue